// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"bfc6d095","212":"e03acce5","780":"c6b90d39","842":"48f8bd6f"}[chunkId] + ".js";
};